import React from "react";
import textWeight from "../../utils/textWeight";
import { useWindowWidth } from "../../utils/helpers";
import { ReactSVG } from "react-svg";

const Text = ({
  text = "",
  weight,
  size,
  color = "text-dark-grey",
  className,
  isRequired,
  isColon = false,
  onClick,
  isCenter,
  style,
  isDisabled,
  isTruncate = true,
  align,
  iconClassName,
  icon,
}) => {
  const { TextWeight } = textWeight();
  const width = useWindowWidth();

  return (
    <p
      style={{
        fontSize: width > 640 ? size : size - 2,
        fontFamily: weight ? weight : TextWeight.Onest_regular,
        ...style,
      }}
      className={` ${
        isDisabled ? "text-gray opacity-50 cursor-not-allowed" : color
      } ${isTruncate ? "truncate" : ""} ${
        isCenter ? "text-center" : align ? align : ""
      }  ${className} `}
      onClick={isDisabled ? null : onClick}
    >
      {icon && <ReactSVG src={icon} className={iconClassName} />}
      {isColon ? `${text}:` : text}
      {isRequired && <span className={`text-errorRed`}>*</span>}
    </p>
  );
};

export default Text;
